import gql from 'graphql-tag'

export default gql `
    mutation createBroadcast($input: CreateBroadcastInput!){
        createBroadcast(
            input: $input
        ){
            id
            type
            from
            subject
            body
            delivery
            delivery_date
            state_machine
            status
            created
            updated
            sent
            filters
            recipients
        }
    }
`